import { render, staticRenderFns } from "./JobLevel.vue?vue&type=template&id=27074da9&scoped=true"
import script from "./JobLevel.vue?vue&type=script&lang=js"
export * from "./JobLevel.vue?vue&type=script&lang=js"
import style0 from "./JobLevel.vue?vue&type=style&index=0&id=27074da9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27074da9",
  null
  
)

export default component.exports